import { render, staticRenderFns } from "./form_add_bonus_component.vue?vue&type=template&id=7a6f9610&scoped=true"
import script from "./form_add_bonus_component.vue?vue&type=script&lang=js"
export * from "./form_add_bonus_component.vue?vue&type=script&lang=js"
import style0 from "./form_add_bonus_component.vue?vue&type=style&index=0&id=7a6f9610&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f9610",
  null
  
)

export default component.exports